// extracted by mini-css-extract-plugin
export default {"brand":"BrandButton_brand__qxZDT"};